import * as THREE from "three";

export const WOODF = [
  {
    name: "Oak",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Oak1/oak_front_color.jpg",
    normalMap: "./textures/wood4k/front/Oak1/oak_front_normal.jpg",
    roughnessMap: "./textures/wood4k/front/Oak1/oak_front_roughness.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Africa Walnut 1",
    listName: "WOODF",
    texture:
      "./textures/wood4k/front/AfricanWalnut1/africanwalnut1_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/AfricanWalnut1/africanwalnut1_front_roughness.jpg",
    normalMap:
      "./textures/wood4k/front/AfricanWalnut1/africanwalnut1_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Africa Walnut 2",
    listName: "WOODF",
    texture:
      "./textures/wood4k/front/AfricanWalnut2/africanwalnut2_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/AfricanWalnut2/africanwalnut2_front_roughness.jpg",
    normalMap:
      "./textures/wood4k/front/AfricanWalnut2/africanwalnut2_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Pine",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Pine/pine_front_color.jpg",
    roughnessMap: "./textures/wood4k/front/Pine/pine_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Pine/pine_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Pine Clear",
    listName: "WOODF",
    texture: "./textures/wood4k/front/PineClear/pineclear_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/PineClear/pineclear_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/PineClear/pineclear_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Maple",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Maple/maple_front_color.jpg",
    roughnessMap: "./textures/wood4k/front/Maple/maple_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Maple/maple_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "American Walnut",
    listName: "WOODF",
    texture:
      "./textures/wood4k/front/AmericanWalnut/americanwalnut_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/AmericanWalnut/americanwalnut_front_roughness.jpg",
    normalMap:
      "./textures/wood4k/front/AmericanWalnut/americanwalnut_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Cherry",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Cherry/cherry_front_color.jpg",
    roughnessMap: "./textures/wood4k/front/Cherry/cherry_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Cherry/cherry_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Mahogany",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Mahogany/mahogany_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/Mahogany/mahogany_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Mahogany/mahogany_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Lime",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Lime/lime_front_color.webp",
    roughnessMap: "./textures/wood4k/front/Lime/lime_front_roughness.webp",
    normalMap: "./textures/wood4k/front/Lime/lime_front_normal.webp",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Silver",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Silver/silver_front_color.jpg",
    roughnessMap: "./textures/wood4k/front/Silver/silver_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Silver/silver_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 0.8,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 3,
  },
  {
    name: "Gold",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Gold/gold_front_color.jpg",
    roughnessMap: "./textures/wood4k/front/Gold/gold_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Gold/gold_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 0.8,
    metalness: 0.1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 3,
  },
  {
    name: "Dark Walnut",
    listName: "WOODF",
    texture: "./textures/wood4k/front/DarkWalnut/darkwalnut_front_color.jpg",
    roughnessMap:
      "./textures/wood4k/front/DarkWalnut/darkwalnut_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/DarkWalnut/darkwalnut_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Wenga",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Wenga/wenga_front_color_c.jpg",
    roughnessMap: "./textures/wood4k/front/Wenga/wenga_front_roughness.jpg",
    normalMap: "./textures/wood4k/front/Wenga/wenga_front_normal.jpg",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Beech",
    listName: "WOODF",
    texture: "./textures/wood4k/front/Beech/Beech_Front_Color.jpg",
    roughnessMap: "./textures/wood4k/front/Beech/Beech_Front_Roughess.jpg",
    normalMap: "./textures/wood4k/front/Beech/Beech_Front_Normal.png",
    size: [0.01, 0.2, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Wash White",
    listName: "WOODF",
    texture: "./textures/wood4k/front/PineWash/PineWash_Front_Color.jpg",
    roughnessMap:
      "./textures/wood4k/front/PineWash/PineWash_Front_Roughness.jpg",
    normalMap: "./textures/wood4k/front/PineWash/PineWash_Front_Normal.png",
    size: [0.01, 0.4, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
];
